import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5637 17.36C19.9998 16.711 21 15.2651 21 13.5858C21 10.9899 19.1698 9.44677 16.897 9.44579C16.897 7.81314 15.6165 4.54688 12 4.54688C8.38346 4.54688 7.10303 7.81314 7.10303 9.44579C4.83308 9.46525 3 10.9899 3 13.5858C3 15.2651 3.99924 16.711 5.43632 17.36",
			stroke: "#000000",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.22852 15.2281L11.9995 12.457L14.7706 15.2281",
			stroke: "#000000",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 12.457L12.0006 19.4512",
			stroke: "#000000",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgUploadLine;
